import api from './api';

let common = {
  title: '中国广告者协会'
};

common.navData = [
  {
    text: '首页',
    leftchild: []
  },
  {
    text: '协会概览',
    leftchild: [
      '协会概况',
      '协会章程',
      // '微信公众号',
    ]
  },
  {
    text: '新闻动态',
    leftchild: [
      '协会动态',
      '行业要闻',
      '会员动态',
      '党建活动',
      '通知公告',
    ]
  },
  {
    text: '会员服务',
    leftchild: [
      '会员权益',
      '入会流程',
    ]
  },
  {
    text: '分支机构',
    leftchild: [
      '分支机构',
    ]
  },
  {
    text: '国际交流',
    leftchild: [
      '世广联',
      '论坛会展',
      '活动日历',
    ]
  },
  {
    text: '专题活动',
    leftchild: [
      '近期活动',
      '活动回顾',
    ]
  },
  {
    text: '学术研究',
    leftchild: [
      '行业报告',
      '课题研究',
      '标准认证',
    ]
  },
  {
    text: '协会服务',
    leftchild: [
      '品牌建设',
      '营销传播',
      '合规咨询',
      '知识产权',
      '广告反欺诈',
      '标准认证',
      '教育培训',
    ]
  },
];


export default common;



// WEBPACK FOOTER //
// ./src/model/common.js